import { Instance, types } from 'mobx-state-tree';
import { OfferType } from '../api/proto/apiContract';

export const OddModel = types.model({
    ident: types.string,
    key: types.string,
    name: types.string,
    nameForTicket: types.maybeNull(types.string),
    popularity: types.maybeNull(types.number),
    rate: types.number,
    isHighlighted: types.maybeNull(types.boolean),
    hasCustomText: types.maybeNull(types.boolean), // true means it contains specific text that cannot be cut. False means translated 1/2/X to competitor/draw that can be shortened with ... (always 3 in row)
    isSuspended: types.boolean // expected as aggregate of event, detail (live) and odd suspended (both prematch and live)
}).actions(self => {

    const setRate = (value: number): void => {
        self.rate = value;
    }

    return {
        setRate
    }

});

export type IOddStore = Instance<typeof OddModel>;

export interface IOdd {
    ident: string;
    key: string;
    name: string;
    nameForTicket: string | null;
    popularity: number;
    rate: number;
    isHighlighted: boolean;
    isSuspended: boolean;
}

export interface IOddsExtData {
    eventName: string;
    gameName: string;
    hasDetail: boolean;
    detailName: string; //null if hasDetail is false
    eventDate: Date; //not necessary for live
    number: number | null; //for MTS expected non null
    offerType: OfferType;
}